;(function($){

  // Foundation JavaScript
  // Documentation can be found at: http://foundation.zurb.com/docs
  $(document).foundation();

  $(document).ready(function() {

    /* Replace search box contents */

    var searchPhrase = 'Enter keyword(s) to search';
    $('#SearchForm_SearchForm_Search').on('focus', function(){
        $(this).addClass('active');
        if($(this).val() == searchPhrase){
      $(this).val('');
        }
    });
    $('#SearchForm_SearchForm_Search').on('blur', function(){
        if($(this).val() == ''){
      $(this).val(searchPhrase);
      $(this).removeClass('active');
        }
    });


    // Signup

    $('#signup').submit(function() {
        $("#message").html("Adding your email address...");

        var $form = $('#signup');
        console.log($form.serialize());
        $.ajax({
            type: $form.attr('method'),
            url: $form.attr('action'),
            data: $form.serialize(),
            cache       : false,
            dataType    : 'jsonp',
            contentType: "application/json; charset=utf-8",
            error       : function(err) {
              alert("Could not connect to the registration server. Please try again later.");
            },
            success     : function(data) {
              $('#message').html(data.msg);
            }
        });

        return false;
    });

    subscribeModal = new Foundation.Reveal(jQuery("#subscribeModal"))
    isOpen = false;
    $(".subscribeToggle").click(function() {
      isOpen = !isOpen;
      if(isOpen) {
        subscribeModal.open();
      }
      else {
        subscribeModal.close();
      }
    });

  });

 })(jQuery);

 